import { useIntegrationContext } from '@aibees/elephant/components/export-dialog/context/integration-context';
import {
  IntegrationConnection,
  IntegrationType,
} from '@aibees/elephant/types/integration';
import { useState } from 'react';
import { useBrowseIntegrationApi } from './use-browse-integration-api';

interface UseInfiniteIntegrationResult {
  integration?: IntegrationConnection[];
  isLoadingInitial: boolean;
}

export const useInfiniteIntegration = (
  type?: IntegrationType
): UseInfiniteIntegrationResult => {
  const { setIntegration } = useIntegrationContext();
  const [loading, setLoading] = useState(false);

  const { data, isLoading } = useBrowseIntegrationApi(
    {
      type,
    },
    {
      onSuccess(response) {
        setLoading(false);
        setIntegration(response);
      },
      onError() {
        setLoading(false);
      },
    }
  );

  return {
    integration: data?.content,
    isLoadingInitial: isLoading,
  };
};
